export const freeCalendarResourceInclude = 'organization,salesman,team,products';

export const dashboardCallReminderInclude = 'client,building,building.condominium';
